import { fetchAreasOrgchart } from "src/Pages/Company/OrganizationStructure/api";
import { useQuery } from "@tanstack/react-query";
import { OrgchartType } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/FilterBar.models";
import useOrgchartAreasStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Areas/store";
import type { Edge, Node } from "@xyflow/react";
// eslint-disable-next-line
import { getInitialDataWorker } from "../workers/getOrgchartWebWorker";

const InitialDataModificationWorker: Worker | undefined =
  getInitialDataWorker();

interface IWebWorker {
  initialNodes: Node[];
  initialEdges: Edge[];
}

export const useAreasOrgchartData = ({
  companyId,
  structureId,
}: {
  companyId: string;
  structureId: string;
}) =>
  useQuery({
    queryKey: ["areasOrgchart", companyId, structureId],
    queryFn: async () => {
      const data = await fetchAreasOrgchart(companyId, structureId);

      InitialDataModificationWorker.postMessage({
        orgchartData: data,
        orgchartType: OrgchartType.Areas,
      });

      InitialDataModificationWorker.onmessage = (
        event: MessageEvent<IWebWorker>
      ) => {
        event.data.initialNodes.forEach((node) => {
          if (node.data.hasChildren) {
            useOrgchartAreasStore
              .getState()
              .setChildrenCollapsedStatus(
                new Map(
                  useOrgchartAreasStore.getState().childrenCollapsedStatus
                ).set(node.id, node.id !== "root")
              );
          }
        });
        useOrgchartAreasStore.getState().setAllNodes(event.data.initialNodes);
        useOrgchartAreasStore
          .getState()
          .setNodes(
            event.data.initialNodes.filter((node) => node.hidden === false)
          );
        useOrgchartAreasStore.getState().setEdges(event.data.initialEdges);
      };

      return data;
    },
  });
